import { IconProps } from "../types";

export const asIcon = <P extends IconProps>(
    WrappedComponent: React.ComponentType<P>
): React.FunctionComponent<P> => {
    const Wrapper = (props: P) => {
        return (
            <span className="icon" data-testid="icon">
                <WrappedComponent {...props} />
            </span>
        );
    };
    return Wrapper;
};
